import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IconComponent } from '@eai-tdv/shared/icon';

import { IconGoalWrapComponent } from '../../../../../shared/components/icon-goal-wrap/icon-goal-wrap.component';

@Component({
  imports: [NgClass, NgIf, IconGoalWrapComponent, IconComponent],
  selector: 'tdv-upload-resource-progress-img',
  templateUrl: './upload-resource-progress-img.component.html',
  styleUrls: ['./upload-resource-progress-img.component.scss'],
})
export class UploadResourceProgressImgComponent {
  @Input() isLoaded?: boolean;
  @Input() base64?: string;
  @Input({ required: true }) isDicom!: boolean;
}
